import React, { useEffect, useRef, useState } from 'react';
import styles from './progress-tracker.module.css';
import { useNavigate } from 'react-router';
import { useAppState } from '../../../../overmind';
import { PagePath } from '../../../../navigation/navigation.enums';

export function ProgressTracker(): JSX.Element {
  const { freemiumAccount } = useAppState();
  const [open, setOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const menuRef = useRef<HTMLDivElement>(null);
  function onClickWindowHandler(event: MouseEvent): void {
    if (!open) return;
    if (!menuRef.current?.contains(event.target as any)) setOpen(false);
  }
  const handleTaskClick = (path?: string) => {
    if (path) {
      navigate(path);
    }
  };

  useEffect(() => {
    if (!open) return () => window.removeEventListener('click', onClickWindowHandler);

    window.requestIdleCallback(() => window.addEventListener('click', onClickWindowHandler));

    return () => window.removeEventListener('click', onClickWindowHandler);
  }, [open]);

  return !!freemiumAccount ? (
    <div className={styles.progressTrackerContainer}>
      <div className={styles.progressSummary} onClick={() => setOpen(true)}>
        <div className={styles.progressText}>
          <span className={styles.progressLabel}>Progress</span>
          <span className={styles.progressPercentage}>{freemiumAccount.progress.percentageComplete}%</span>
        </div>
        <div className={styles.progressBar}>
          <div
            className={styles.progressBarFill}
            style={{ width: `${freemiumAccount.progress.percentageComplete}%` }}
          />
        </div>
      </div>
      {open && (
        <div ref={menuRef} className={styles.progressDropdown}>
          <div className={styles.progressTaskList}>
            <h3 className={styles.progressTaskListTitle}>Complete these tasks</h3>
            <ul className={styles.taskList}>
              <li
                className={`${styles.taskItem} ${freemiumAccount.progress.hasCompanyInformation ? styles.taskCompleted : ''}`}
                onClick={() => handleTaskClick(PagePath.onboarding)}
              >
                <div className={styles.taskCheckbox}>{freemiumAccount.progress.hasCompanyInformation ? '✓' : ''}</div>
                <div className={styles.taskDetails}>
                  <span className={styles.taskLabel}>Company Information</span>
                  <span className={styles.taskDescription}>Add company details like name, industry, and size</span>
                </div>
              </li>
              <li
                className={`${styles.taskItem} ${freemiumAccount.progress.hasSelectedInterests ? styles.taskCompleted : ''}`}
                onClick={() => handleTaskClick(PagePath.onboarding)}
              >
                <div className={styles.taskCheckbox}>{freemiumAccount.progress.hasSelectedInterests ? '✓' : ''}</div>
                <div className={styles.taskDetails}>
                  <span className={styles.taskLabel}>Interests</span>
                  <span className={styles.taskDescription}>Select roles, skills, and teams of interest</span>
                </div>
              </li>
              <li
                className={`${styles.taskItem} ${freemiumAccount.progress.hasCompanyDescription ? styles.taskCompleted : ''}`}
                onClick={() => handleTaskClick(PagePath.onboarding)}
              >
                <div className={styles.taskCheckbox}>{freemiumAccount.progress.hasCompanyDescription ? '✓' : ''}</div>
                <div className={styles.taskDetails}>
                  <span className={styles.taskLabel}>Company Description</span>
                  <span className={styles.taskDescription}>Add description and upload relevant documents</span>
                </div>
              </li>
              <li
                className={`${!freemiumAccount?.initialOnboardingComplete ? styles.taskItemDisabled : ''} 
              ${styles.taskItem} 
              ${freemiumAccount.progress.hasUploadedUsers ? styles.taskCompleted : ''}`}
                onClick={() => {
                  if (freemiumAccount?.initialOnboardingComplete) {
                    handleTaskClick(`${PagePath.userManagementBase}${PagePath.userManagementPeople}`);
                  }
                }}
              >
                <div className={styles.taskCheckbox}>{freemiumAccount.progress.hasUploadedUsers ? '✓' : ''}</div>
                <div className={styles.taskDetails}>
                  <span className={styles.taskLabel}>Upload Users</span>
                  <span className={styles.taskDescription}>Upload your team members via CSV</span>
                </div>
              </li>
              <li
                className={`${!freemiumAccount?.initialOnboardingComplete ? styles.taskItemDisabled : ''} 
              ${styles.taskItem} 
              ${freemiumAccount.progress.hasCompletedPeerAssessment ? styles.taskCompleted : ''}`}
                onClick={() => {
                  if (freemiumAccount?.initialOnboardingComplete) {
                    handleTaskClick(PagePath.yourAssessmentsBase);
                  }
                }}
              >
                <div className={styles.taskCheckbox}>{freemiumAccount.progress.hasCompletedPeerAssessment ? '✓' : ''}</div>
                <div className={styles.taskDetails}>
                  <span className={styles.taskLabel}>Complete Peer Assessment</span>
                  <span className={styles.taskDescription}>Rate your teams skills to start richer seeing analytics</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      )
      }
    </div>
  ) : <></>;
}
